// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    LINKED_GROUP_TEAM: null,
    LINKED_GROUP_CHANNEL: null,

    UNLINKED_GROUP_TEAM: null,
    UNLINKED_GROUP_CHANNEL: null,

    RECEIVED_GROUP_TEAMS: null,
    RECEIVED_GROUP_CHANNELS: null,

    RECEIVED_GROUP_STATS: null,

    RECEIVED_GROUP: null,

    RECEIVED_GROUPS: null,

    RECEIVED_GROUP_ASSOCIATED_TO_TEAM: null,
    RECEIVED_GROUPS_ASSOCIATED_TO_TEAM: null,

    RECEIVED_ALL_GROUPS_ASSOCIATED_TO_CHANNELS_IN_TEAM: null,

    RECEIVED_GROUP_ASSOCIATED_TO_CHANNEL: null,
    RECEIVED_GROUPS_ASSOCIATED_TO_CHANNEL: null,

    RECEIVED_ALL_GROUPS_ASSOCIATED_TO_TEAM: null,

    RECEIVED_ALL_GROUPS_ASSOCIATED_TO_CHANNEL: null,

    RECEIVED_GROUP_NOT_ASSOCIATED_TO_TEAM: null,
    RECEIVED_GROUPS_NOT_ASSOCIATED_TO_TEAM: null,

    RECEIVED_GROUP_NOT_ASSOCIATED_TO_CHANNEL: null,
    RECEIVED_GROUPS_NOT_ASSOCIATED_TO_CHANNEL: null,

    PATCHED_GROUP_TEAM: null,
    PATCHED_GROUP_CHANNEL: null,

    RECEIVED_MY_GROUPS: null,

    PATCHED_GROUP: null,
});
